import * as React from 'react'

import type { Moment } from 'moment'
import ReactTooltip from 'react-tooltip'
import { ActivityTooltip } from '../ActivityTooltip'

type ActivityTooltipRendererProps = {
  translate: (text) => any
  startTime: Moment
}

const ActivityTooltipRenderer: React.FC<ActivityTooltipRendererProps> = ({
  translate,
  startTime,
}) => {
  return (
    <ReactTooltip
      id="activityTooltip"
      aria-haspopup="true"
      place="top"
      effect="float"
      key={'activityTooltip' + startTime}
      role="example"
      className="!tw-border-0 !tw-bg-transparent !tw-p-0 !tw-opacity-100 !tw-shadow-none"
      backgroundColor="transparent"
      border={false}
      borderColor="transparent"
      type="dark"
      offset={{ top: 10 }}
      getContent={(data) => {
        return data == null ? null : (
          <ActivityTooltip activity={JSON.parse(data)} translate={translate} />
        )
      }}
      overridePosition={({ left, top }, currentEvent, currentTarget, node) => {
        const d = document.documentElement

        left = Math.min(d.clientWidth - node.clientWidth, left)
        top = Math.min(d.clientHeight - node.clientHeight, top)
        left = Math.max(20, left)
        top = Math.max(0, top)

        return { top, left }
      }}
    />
  )
}

export default ActivityTooltipRenderer
